import { useTranslation } from 'react-i18next'

import { REQUEST_PROFILE_CHANGE_TYPE } from '../../../../../constants/request'
import { useInitData, useNotification } from '../../../../../hooks'
import {
  getRequestPostFormInitialValues,
  NewsboardPostFormModal,
} from '../../../../Newsboard'
import { getPostCreationSuccessNotification } from '../../../../Post'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'

export function useRequestProfileCreatePostAction() {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  const { availableSections } = useInitData()

  const { handleCloseModal, handleReloadAfterChange, requestData, setModal } =
    useRequestProfileContext()

  function handlePostSuccess({ title, uuid }) {
    handleCloseModal()
    handleAddSuccessNotification(
      getPostCreationSuccessNotification({ availableSections, t, title, uuid })
    )
    handleReloadAfterChange(REQUEST_PROFILE_CHANGE_TYPE.posts)
  }

  const { getInitialValues, recipientInitialValues } =
    getRequestPostFormInitialValues(requestData)

  function handleClickCreatePost() {
    setModal(
      <NewsboardPostFormModal
        getInitialValues={getInitialValues}
        recipientInitialValues={recipientInitialValues}
        onClose={handleCloseModal}
        onSuccess={handlePostSuccess}
      />
    )
  }

  return { handleClickCreatePost }
}
